const options = [
  {
    key: '',
    label: 'sidebar.dashboard',
    permissions: ['Login'],
    leftIcon: 'ion-md-home',
  },
  {
    key: 'users',
    label: 'sidebar.users',
    permissions: ['Login', 'UserEditor'],
    leftIcon: 'ion-md-contacts',
  },
  {
    key: 'usergroups',
    label: 'User Groups',
    permissions: ['Login', 'UserGroupsEditor'],
    leftIcon: 'ion-ios-people',
  },
  {
    key: 'locations',
    label: 'Locations',
    permissions: ['Login', 'LocationsEditor'],
    leftIcon: 'ion-md-pin',
  },
  {
    key: 'access',
    label: 'Access Levels',
    permissions: ['Login', 'AccessLevelsEditor'],
    leftIcon: 'ion-md-lock',
  },
  {
    key: 'log',
    label: 'Log Viewer',
    permissions: ['Login', 'LogViewer'],
    leftIcon: 'ion-md-cube',
  },
  /*
  {
    key: 'authcheck',
    label: 'sidebar.authCheck',
    leftIcon: 'ion-md-checkmark',
  },
  {
    key: 'support',
    label: 'sidebar.support',
    leftIcon: 'ion-ios-help-buoy',
  },
  // sidebar route for testing
  {
    key: 'development',
    label: 'sidebar.development',
    leftIcon: 'ion-ios-bug',
  },
  */
];
export default options;
